import { createApp } from "vue";
import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import App from "./tpls/index.vue";
import 'vant/es/toast/style';

// 性能监控 
const params = new URLSearchParams(window.location.search);
const paramLang = params.get('lang');
let lang = ''
let countryArr = ['in_id', 'es_es', 'en_us', 'ru_ru', 'pt_br', 'es_us', 'en_gb', 'tr_tr', 'fr_fr', 'de_de']
if (paramLang && countryArr.includes(paramLang.toLowerCase())) {

  if (paramLang.toLowerCase() == 'in_id') {
    lang = 'id'
  } else if (paramLang.toLowerCase() == 'pt_br') {
    lang = 'br'
  } else if (paramLang.toLowerCase() == 'es_us' || paramLang.toLowerCase() == 'en_gb') {
    lang = paramLang.toLowerCase()
  } else {
    lang = paramLang.slice(0, 2)
  }
} else {
  lang = 'en'
}
const returnCountry = () => {
  if (lang == 'id') {
    return "https://apm-rum-sgp.inf.miui.com"
  } else if (lang == 'es' || lang == 'es_us' || lang == 'de' || lang == 'fr') {
    return "https://apm-rum-eu.inf.miui.com"
  } else if (lang == 'en' || lang == 'en_gb' || lang == 'tr') {
    return "https://apm-rum-sgp.inf.miui.com"
  } else if (lang == 'ru') {
    return "https://apm-rum-ru.inf.miui.com"
  } else if (lang == 'br') {
    return "https://apm-rum-eu.inf.miui.com"
  }
  //  else if (lang == 'Italy') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Portugal') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Turkish') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'German') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // }
}
const options = {
  /*
    * 合规要求，不同集群服务需上报到不同apm集群
    * 测试环境：https://apm-staging.inf.miui.com
    * 线上环境新加坡集群：https://apm-rum-sgp.inf.miui.com
    * 线上环境俄罗斯集群：https://apm-rum-ru.inf.miui.com
    * 线上环境印度集群：https://apm-rum-ind.inf.miui.com
    * 线上环境欧洲集群：https://apm-rum-eu.inf.miui.com
    */
  serverUrl: returnCountry(),
  // 如 cp-wuli-widget-h5
  serviceName: `cp-wuli-xiaomi-widget-can`,
  // 服务版本号，可以用git的commit id
  serviceVersion: '1.0.1',
  /*
   * 服务环境
   * 测试环境：staging
   * 预发环境：preview
   * 线上环境：production
   */
  environment: 'production',
  // 是否开启上报，建议本地开发环境不上报
  active: import.meta.env.MODE == "development" ? false : true,
}
const app = createApp(App);
app.use(ApmVuePlugin, { config: options })
app.mount("#app");

app.config.globalProperties.$apm?.addLabels?.({ group: 'global-miui-fe-cp' });
